import { Card } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Title = styled.p`
  font-size: 3rem;
  text-align: center;
`;

export const CategoryText = styled.p`
  font-size: 1.125rem;
  text-transform: uppercase;
  text-align: center;
  color: #5ABBA4;
`;

export const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  margin-top: 2rem;
  gap: 10px;
`;

export const CommunityTag = styled.div`
  padding: .25rem .5rem;
  margin-bottom: .5rem;
  background-color: #e2e8f0;
  border-radius: .5rem;
`;

export const CommunityTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 3px;
  margin-top: 8px;
`;

export const CoverImageWrapper = styled.div`
  margin-top: 10px;
  > .ant-image {
    width: 100%;
  }
`;

export const CommunityBody = styled.div`

`;

export const CommunityCommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const CommunityCommentCard = styled(Card)`
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  .ant-card-body {
    padding: 0.75rem;
    > div {
      display: flex;
      gap: 8px;
      > .avatar-wrapper {
      }

      > .user-info {
        > div {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          > .owner-name {
            font-weight: bold;
            color: black;
          }

          > .gray-color {
            color: #a0aec0;
          }
        }
      }
    }

    > .edit-comment-input {
      width: 100%;
      margin-top: 1.2rem;
      flex-direction: column;
    }
  }
`;